<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      width: 100%;
    "
  >
    <div>
      <div style="border-bottom: 1px solid #e5e5e5">
        <!-- <div class="isLogin wrapper" v-if="!sessionId">
          <div class="loginBox" @click="goLogin(1)">
            <img src="@/image/login.png" alt="" />登录
          </div>
          <div class="regBox" @click="goLogin(2)">
            <img src="@/image/reg.png" alt="" />注册
          </div>
        </div> -->
        <div class="isLogin wrapper" v-if="sessionId">
          <el-dropdown @command="command">
            <span class="el-dropdown-link">
              <div class="ftc66" style="width: 100%; display: flex;cursor: pointer;">
                <div class="loginName">
                  <img
                    src="@/image/login.png"
                    alt=""
                    style="width: 14px; height: 14px; display: block"
                  />
                </div>
                {{ backstageUser.userName }}
                <div class="loginName">
                  <img
                    src="@/image/jt.png"
                    alt=""
                    style="width: 7px; height: 5px; display: block"
                  />
                </div>
              </div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">处置平台服务中心</el-dropdown-item>
              <el-dropdown-item :command="3">修改密码</el-dropdown-item>
              <el-dropdown-item :command="2">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="headerTitle">
        <div class="headerBox wrapper">
          <div style="display: flex;">
            <img src="@/image/logo.png" class="logo-pic" />
            <!-- <div class="fs22 color ftb">重庆交运集团废旧物资处置平台</div> -->
            <div class="fs22 color ftb">招投标管理系统</div>
          </div>
          
          <div class="spanList fs16">
            <span
              :class="current == index ? 'ftc14D' : 'ftc66'"
              @click="spanChange(index, item.path)"
              v-for="(item, index) in titleList"
              :key="index"
              >{{ item.title }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 路由出口 -->
    <router-view></router-view>
    <!-- 页脚 -->
    <footerBox v-if="current != 4"></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer.vue";
import {loginOut} from "@/api/login"
export default {
  components: {
    footerBox,
  },
  data() {
    return {
      titleList: [
        {
          title: "首页",
          path: "/home/homepage",
        },
        {
          title: "招标公告",
          path: "/home/bidding",
        },
        {
          title: "拍卖",
          path: "/home/auction",
        },
        {
          title: "竞买",
          path: "/home/competitionBuy",
        },
        {
          title: "竞争比价",
          path: "/home/competitiveprice",
        },
        
        {
          title: "投标报价",
          path: "/home/tenderlogin",
        },
        
      ],
      current: 0, //默认首页
      sessionId: "",
      backstageUser: {},
    };
  },
  mounted() {
    this.current = this.$route.meta.activeMenuIndex;
    this.sessionId = sessionStorage.getItem("sessionId");
    this.backstageUser = JSON.parse(sessionStorage.getItem("backstageUser"));
    console.log();
  },
  methods: {
    spanChange(val, path) {
      this.current = val
      this.$router.push({
        path,
      });
      // if(val==4) {
      //   sessionStorage.removeItem("auctionProjectId");
      // }
    },
    command(e) {
      if (e == 2) {
        loginOut({sessionId: this.sessionId}).then(res=>{
          if(res.data.code==1) {
            sessionStorage.removeItem("sessionId");
            this.$message.success(res.data.msg)
            this.$router.go(0)
          }
        })
      }
      if (e == 1) {
        this.$router.push({
          path: "/servicecenter",
        });
      }
      if (e == 3) {
        this.$router.push({
          path: "/servicecenter/modifypwd",
        });
      }
    },
    goLogin(current) {
      this.$router.push({
        path: "/login",
        query: {
          current,
        },
      });
    },
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        this.current = newVal.meta.activeMenuIndex;
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.color {
  color: #032274;
}
.logo-pic {
  width:88px;
  height:68px;
  padding:12px 20px 0 0;
}
.loginName {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}

.isLogin {
  display: flex;
  height: 40px;
  line-height: 40px;
  justify-content: flex-end;
  text-align: center;

  .regBox {
    border-right: 1px solid #e5e5e5;

    img {
      width: 15px;
      height: 15px;
    }
  }
}

.loginBox,
.regBox {
  display: flex;
  align-items: center;
  width: 100px;
  justify-content: center;
  cursor: pointer;

  img {
    display: block;
    padding: 0 10px 0 0;
  }
}

.loginBox {
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;

  img {
    width: 14px;
    height: 16px;
  }
}

.headerTitle {
  box-shadow: 0px 5px 10px 0px rgba(197, 197, 197, 0.2);
}

.headerBox {
  height: 100px;
  line-height: 100px;
  display: flex;
  justify-content: space-between;

  .spanList {
    span {
      padding-left: 30px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/main/index.vue